var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandshake({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "handshake",
    transform: "translate(-597.5 -800)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-handshake",
    transform: "translate(593.5 796.492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1735",
    "data-name": "Path 1735",
    d: "M53.2,36.8,36.25,19.85,40,17l-3-3H16.75L4,11V35l8.85,1.5,18,18.3a2.9,2.9,0,0,0,4.2,0h0a2.9,2.9,0,0,0,0-4.2l-.15-.15h0a.742.742,0,1,1,1.05-1.05h0l1.2,1.2a2.9,2.9,0,0,0,4.2,0h0a2.9,2.9,0,0,0,0-4.2l-.45-.45h0a.742.742,0,1,1,1.05-1.05h0l1.5,1.5a2.9,2.9,0,0,0,4.2,0h0a2.9,2.9,0,0,0,0-4.2l-.45-.45a.742.742,0,0,1,1.05-1.05h0l.45.45a2.9,2.9,0,0,0,4.2,0h0A2.856,2.856,0,0,0,53.2,36.8Z",
    transform: "translate(0 0.247)",
    fill: "#ffb74d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1736",
    "data-name": "Path 1736",
    d: "M36.65,23.1,29.6,25.8a10.623,10.623,0,0,1-11.85-2.7h0A1.305,1.305,0,0,1,18.2,21l19.95-9.75a7.184,7.184,0,0,1,7.35.6l.6.45a7.336,7.336,0,0,0,5.85,1.05l9.6-2.1v24l-8.85,1.5-1.2,1.2Zm-14.1,30.15h0a2.9,2.9,0,0,0,4.2,0L27.8,52.2a2.9,2.9,0,0,0,0-4.2h0a2.9,2.9,0,0,0-4.2,0l-1.05,1.05A2.9,2.9,0,0,0,22.55,53.247Zm-4.35-4.2h0a2.9,2.9,0,0,0,4.2,0L23.45,48a2.9,2.9,0,0,0,0-4.2h0a2.9,2.9,0,0,0-4.2,0l-1.05,1.05A3.192,3.192,0,0,0,18.2,49.047Zm-4.2-4.2h0a2.9,2.9,0,0,0,4.2,0l1.05-1.05a2.9,2.9,0,0,0,0-4.2h0a2.9,2.9,0,0,0-4.2,0L14,40.647A2.9,2.9,0,0,0,14,44.847ZM9.8,40.5h0a2.9,2.9,0,0,0,4.2,0l1.05-1.05a2.9,2.9,0,0,0,0-4.2h0a2.9,2.9,0,0,0-4.2,0L9.8,36.3A2.9,2.9,0,0,0,9.8,40.5Z",
    transform: "translate(2.45)",
    fill: "#c77600"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_633",
    "data-name": "Group 633",
    transform: "translate(13.9 35.697)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1737",
    "data-name": "Path 1737",
    d: "M25.45,43.2,23.2,41.1l.6-.6a1.281,1.281,0,0,1,1.95,0l.15.15a1.281,1.281,0,0,1,0,1.95ZM21.1,39,19,36.9l.6-.6a1.281,1.281,0,0,1,1.95,0l.15.15a1.281,1.281,0,0,1,0,1.95Zm-4.2-4.2-2.1-2.1.6-.6a1.281,1.281,0,0,1,1.95,0l.15.15a1.281,1.281,0,0,1,0,1.95Zm-4.2-4.2-2.1-2.25.6-.6a1.281,1.281,0,0,1,1.95,0l.15.15a1.281,1.281,0,0,1,0,1.95Z",
    transform: "translate(-10.6 -27.3)",
    fill: "#ebae55"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_430",
    "data-name": "Rectangle 430",
    width: 60,
    height: 60,
    transform: "translate(597.5 800)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshake);
export default __webpack_public_path__ + "static/media/handshake.efc536f057ed43d99a641ecaa423736e.svg";
export { ForwardRef as ReactComponent };